var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewPassword({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "Iconz/new_password"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5.646 9.183v7.415M15.431 2.16l.746 2.014 2.014.746-2.014.745-.746 2.014-.745-2.014-2.014-.745 2.014-.746.745-2.014Zm-2.1 13.523 1.355-1.342 2.034 1.395 1.645-2.007 1.718 2.06c1.61.025 2.943-1.33 2.917-3.026-.027-1.696-1.306-3.092-2.917-3.117L10.23 9.51v-.438c-.042-2.666-2.052-4.858-4.584-4.898-2.53-.039-4.688 2.09-4.645 4.755v7.898c.042 2.665 2.114 4.858 4.645 4.897 2.532.04 4.626-2.09 4.584-4.755v-1.316l3.102.03Zm5.034 1.286.745 2.014 2.014.746-2.014.745-.745 2.014-.745-2.014-2.015-.745 2.015-.746.745-2.014Z",
    className: "iconz"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewPassword);
export default __webpack_public_path__ + "static/media/new_password.6ca95ebf3bc8a62692424b6ab3462c76.svg";
export { ForwardRef as ReactComponent };